/**
 * Check if the application is running in mobile view.
 */
export const isMobile = () => {
	if ( window.innerWidth < 800 ) {
		return true;
	}
	return false;
};
